import actionTypes from './types';

export const fetchConsignerVehiclesStart = (payload: any) => ({
  type: actionTypes.FETCH_CONSIGNER_VEHCILES_START,
  payload,
});

export const fetchConsignerVehiclesSuccess = (payload: any) => ({
  type: actionTypes.FETCH_CONSIGNER_VEHCILES_SUCCESS,
  payload,
});

export const resetConsignerVehicles = () => ({
  type: actionTypes.RESET_CONSIGNER_VEHCILES,
});

export const fetchFiltersStart = () => ({
  type: actionTypes.FETCH_FILTERS_START,
});

export const fetchFiltersSuccess = (payload: any) => ({
  type: actionTypes.FETCH_FILTERS_SUCCESS,
  payload,
});

export const fetchItineraryDataStart = (payload: number) => ({
  type: actionTypes.FETCH_ITINERARY_DATA_START,
  payload,
});

export const fetchItineraryDataSuccess = (payload: any) => ({
  type: actionTypes.FETCH_ITINERARY_DATA_SUCCESS,
  payload,
});

export const fetchPathDetailsStart = (payload: number) => ({
  type: actionTypes.FETCH_PATH_DETAILS_START,
  payload,
});

export const fetchPathDetailsSuccess = (payload: any) => ({
  type: actionTypes.FETCH_PATH_DETAILS_SUCCESS,
  payload,
});

export const fetchCurrentLocationStart = (payload: number) => ({
  type: actionTypes.FETCH_CURRENT_LOCATION_START,
  payload,
});

export const fetchCurrentLocationSuccess = (payload: any) => ({
  type: actionTypes.FETCH_CURRENT_LOCATION_SUCCESS,
  payload,
});

export const downloadReport = (payload: any) => ({
  type: actionTypes.DOWNLOAD_REPORT,
  payload,
});
